import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { AbioMedChatComponent } from './components/abiomed-chat/abiomed-chat.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RoleplayStep1Component } from './components/roleplay/roleplay-step1/roleplay-step1.component';
import { RoleplayStep2Component } from './components/roleplay/roleplay-step2/roleplay-step2.component';
import { RoleplayStep3Component } from './components/roleplay/roleplay-step3/roleplay-step3.component';
import { RoleplayStep4Component } from './components/roleplay/roleplay-step4/roleplay-step4.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { RoleplayContainerComponent } from './components/roleplay/roleplay-container/roleplay-container.component';
import { RoleplayProfileComponent } from './components/roleplay/roleplay-profile/roleplay-profile.component';
import { TraineeDasboardComponent } from './components/trainee-dasboard/trainee-dasboard.component';
import { SidebarChatbotComponent } from './components/sidebar-chatbot/sidebar-chatbot.component';
import { TraineeDetailComponent } from './components/trainee-detail/trainee-detail.component';
import { CustFaqComponent } from './components/cust-faq/cust-faq.component';
import { DatePipe } from '@angular/common';
import { DashboardTrainerComponent } from './components/dashboard-trainer/dashboard-trainer.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { SessionEndComponent } from './components/session-end/session-end.component';
import { UnauthorizeduserComponent } from './components/unauthorizeduser/unauthorizeduser.component';
import { HomeComponent } from './components/home/home.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { environment } from '../environments/environment';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MarkdownModule } from 'ngx-markdown';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { RelativeOrDatePipe } from './pipes/relative-or-date.pipe';
import { ProgressPercentPipe } from './pipes/progress-percent.pipe';
import { SelectComponent } from './v2/shared/components/form-controls/select/select.component';

import {
  IPublicClientApplication,
  PublicClientApplication,
  BrowserCacheLocation,
  LogLevel,
  InteractionType,
} from '@azure/msal-browser';
import {
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalInterceptorConfiguration,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
  MsalBroadcastService,
  MsalService,
  MsalGuard,
  MsalRedirectComponent,
  MsalModule,
  MsalInterceptor,
} from '@azure/msal-angular';

import { RoleplayAssignComponent } from './components/roleplay-assign/roleplay-assign.component';
import { TraineeListComponent } from './components/trainee-list/trainee-list.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { RoleplayStep5Component } from './components/roleplay/roleplay-step5/roleplay-step5.component';
import { VeevaVaultDashboardComponent } from './components/veeva-vault-dashboard/veeva-vault-dashboard.component';
import { TrainerAssignedRoleplayComponent } from './components/trainer-assigned-roleplay/trainer-assigned-roleplay.component';
import { UserAssignedRoleplayComponent } from './components/user-assigned-roleplay/user-assigned-roleplay.component';
import { DocumentListComponent } from './components/document-list/document-list.component';
import { LikeDislikeDialogComponent } from './components/like-dislike-dialog/like-dislike-dialog.component';
import { CustomizeDialogComponent } from './components/customize-dialog/customize-dialog.component';
import { CreateProfileComponent } from './components/create-profile/create-profile.component';
import { SystemPromptTabComponent } from './components/system-prompt-tab/system-prompt-tab.component';
import { ResetDialogComponent } from './components/reset-dialog/reset-dialog.component';
import { DoctorProfileComponent } from './components/doctor-profile/doctor-profile.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { FeedbackDialogComponent } from './components/feedback-dialog/feedback-dialog.component';
import { FeedbackTraineeComponent } from './components/feedback-trainee/feedback-trainee.component';
import { VideoConfirmationDialogComponent } from './components/video-confirmation-dialog/video-confirmation-dialog.component';
import { AbiochatReferenceDialogComponent } from './components/abiochat-reference-dialog/abiochat-reference-dialog.component';
import { SecureDocViewerDialogComponent } from './components/secure-doc-viewer-dialog/secure-doc-viewer-dialog.component';
import { HelpDocContentComponent } from './components/help-doc-content/help-doc-content.component';
import { SpeechToTextComponent } from './components/speech-to-text/speech-to-text.component';
import { TruncatePipe } from './service/truncate.pipe';
import { PreLoginComponent } from './components/pre-login/pre-login.component';
import { FullScreenHeaderComponent } from './components/full-screen-header/full-screen-header.component';
import { RoleplayStep6Component } from './components/roleplay/roleplay-step6/roleplay-step6.component';
import { CreateTemplateComponent } from './components/create-template/create-template.component';
import { EmailTemplateComponent } from './components/email-template/email-template.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ProfileInfoComponent } from './components/profile-info/profile-info.component';
import { ProductTypeComponent } from './components/product-type/product-type.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { CreateSourceComponent } from './components/create-source/create-source.component';
import { AccessRequestDialogComponent } from './components/access-request-dialog/access-request-dialog.component';
import { DocumentExpiryComponent } from './components/document-expiry/document-expiry.component';
import { AmpDataSourceListComponent } from './components/amp-data-source-list/amp-data-source-list.component';
import { SelectCheckAllComponent } from './components/select-check-all/select-check-all.component';
import { QuestionListComponent } from './components/question-list/question-list.component';
import { AddQuestiontComponent } from './components/add-questiont/add-questiont.component';
// import { ScheduleOutageComponent } from './components/admin/system-config/schedule-outage/schedule-outage.component';
import { MaintenanceNotificationComponent } from './components/shared/maintenance-notification/maintenance-notification.component';
import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';
import { RoleplayFeedbackComponent } from './components/roleplay-feedback/roleplay-feedback.component';
import { ProductPlatformComponent } from './components/shared/product-platform/product-platform.component';
import { GlobalSpinnerComponent } from './components/shared/global-spinner/global-spinner.component';
import { SpinnerInterceptor } from './core/interceptors/spinner.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { BackendRouteLoggerInterceptor } from './core/interceptors/backend-route-logger.interceptor';
import { CommentHistoryComponent } from './components/feedback/comment-history/comment-history.component';
import { EvaluateFeedbackComponent } from './components/feedback/evaluate-feedback/evaluate-feedback.component';
import { FeedbackConversationTabsComponent } from './components/feedback/feedback-conversation-tabs/feedback-conversation-tabs.component';
import { FeedbackHeaderComponent } from './components/feedback/feedback-header/feedback-header.component';
import { FeedbackCommentTimelineComponent } from './components/feedback/feedback-comment-timeline/feedback-comment-timeline.component';
import { RoleplayHistoryComponent } from './components/history/history.component';
import { RequestListComponent } from './components/ContactCenter/request-list/request-list.component';
import { RequestDetailComponent } from './components/ContactCenter/request-detail/request-detail.component';
import { RoleplayFeedbackListComponent } from './components/ContactCenter/roleplay-feedback-list/roleplay-feedback-list.component';
import { RoleplayFeedbackDetailComponent } from './components/ContactCenter/roleplay-feedback-detail/roleplay-feedback-detail.component';
import { RoleplayFeedbackConversationsDialogComponent } from './components/ContactCenter/roleplay-feedback-detail/roleplay-feedback-conversations-dialog/roleplay-feedback-conversations-dialog.component';
import { AssignTicketDialogComponent } from './components/ContactCenter/assign-ticket-dialog/assign-ticket-dialog.component';
import { AssignTicketToDialogComponent } from './components/ContactCenter/assign-ticket-to-dialog/assign-ticket-to-dialog.component';
import { GridComponent } from './v2/shared/components/ui/grid/grid.component';
import { CreateBugComponent } from './components/ContactCenter/create-bug/create-bug.component';
import { DetailsDescriptionComponent } from './components/ContactCenter/details-description/details-description.component';
import { SearchFieldComponent } from './v2/shared/components/form-controls/search-field/search-field.component';
import { OnboardingProductListComponent } from './v2/modules/onboarding/components/onboarding-product-list/onboarding-product-list.component';
import { RegionMarketSelectComponent } from './v2/shared/components/region-market-select/region-market-select.component';
import { QuizRecentListComponent } from './v2/modules/quiz/components/quiz-recent-list/quiz-recent-list.component';
import { SecureMediaPlayerComponent } from './v2/shared/components/secure-media-player/secure-media-player.component';
import { SystemPromptDialogComponent } from './components/system-prompt-dialog/system-prompt-dialog.component';
const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.client_id,
      authority: environment.authority
      // redirectUri: environment.redirect_url,
    },
    cache: {
      // LocalStorage persists across fresh webview instances (e.g. Salesforce iOS in-app browser)
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(GRAPH_ENDPOINT, ['user.read']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read'],
    },
  };
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    AbioMedChatComponent,
    DashboardComponent,
    RoleplayStep1Component,
    RoleplayStep2Component,
    RoleplayStep3Component,
    RoleplayStep4Component,
    StepperComponent,
    RoleplayContainerComponent,
    RoleplayProfileComponent,
    TraineeDasboardComponent,
    SidebarChatbotComponent,
    RoleplayAssignComponent,
    TraineeListComponent,
    TraineeDetailComponent,
    CustFaqComponent,
    DashboardTrainerComponent,
    SessionEndComponent,
    ConfirmationDialogComponent,
    RoleplayStep5Component,
    UnauthorizeduserComponent,
    HomeComponent,
    VeevaVaultDashboardComponent,
    TrainerAssignedRoleplayComponent,
    UserAssignedRoleplayComponent,
    DocumentListComponent,
    LikeDislikeDialogComponent,
    CustomizeDialogComponent,
    CreateProfileComponent,
    SystemPromptTabComponent,
    ResetDialogComponent,
    DoctorProfileComponent,
    FeedbackComponent,
    FeedbackDialogComponent,
    FeedbackTraineeComponent,
    VideoConfirmationDialogComponent,
    AbiochatReferenceDialogComponent,
    SecureDocViewerDialogComponent,
    HelpDocContentComponent,
    SpeechToTextComponent,
    PreLoginComponent,
    FullScreenHeaderComponent,
    EmailTemplateComponent,
    CreateTemplateComponent,
    RoleplayStep6Component,
    ProfileInfoComponent,
    ProductTypeComponent,
    ProductListComponent,
    CreateSourceComponent,
    AccessRequestDialogComponent,
    DocumentExpiryComponent,
    AmpDataSourceListComponent,
    SelectCheckAllComponent,
    QuestionListComponent,
    AddQuestiontComponent,
    MessageDialogComponent,
    RoleplayFeedbackComponent,
    CommentHistoryComponent,
    EvaluateFeedbackComponent,
    FeedbackConversationTabsComponent,
    FeedbackHeaderComponent,
    FeedbackCommentTimelineComponent,
    RequestListComponent,
    RequestDetailComponent,
    CreateBugComponent,
    DetailsDescriptionComponent,
    SecureMediaPlayerComponent,
    RoleplayFeedbackListComponent,
    RoleplayFeedbackDetailComponent,
    RoleplayFeedbackConversationsDialogComponent,
    AssignTicketDialogComponent,
    AssignTicketToDialogComponent,
    SystemPromptDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    ToastrModule.forRoot(),
    MarkdownModule.forRoot(),
    ReactiveFormsModule,
    MatListModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MsalModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    MatTableModule,
    MatTabsModule,
    MatSortModule,
    NgFor,
    MatMenuModule, MatButtonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    NgxExtendedPdfViewerModule,
    MatSlideToggleModule,
    // ScheduleOutageComponent,
    MaintenanceNotificationComponent,
    ProductPlatformComponent,
    GlobalSpinnerComponent,
    RelativeOrDatePipe,
    ProgressPercentPipe,
    RoleplayHistoryComponent,
    TruncatePipe,
    GridComponent,
    SearchFieldComponent,
    OnboardingProductListComponent,
    SelectComponent,
    RegionMarketSelectComponent,
    QuizRecentListComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BackendRouteLoggerInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    provideAnimationsAsync(),
    DatePipe,
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
  exports: [RelativeOrDatePipe]
})
export class AppModule { }
